export default __webpack_public_path__ + "static/media/joyce_cello.f7a9fc81.png";